import React from 'react';
import { renderToString } from 'react-dom/server';
import QRImage from 'react-qr-image';
import { useDispatch, useSelector } from 'react-redux';
import bwipjs from 'bwip-js';

import { Shipment } from 'services/action';

import { Print } from 'ui/components';
import { currencyFormat, formatDate } from 'utilities/common';

import logoBlack from 'ui/assets/envio-black.png';
import _ from 'underscore';

const POD_URL = `${process.env.REACT_APP_POD_SYSTEM_URL}`;

const PrintResi = ({ match }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const client = useSelector((state) => state?.Auth?.session?.client);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Order.Show']
  );

  const [data, setData] = React.useState(null);
  const [loaded, setLoaded] = React.useState(false);
  const [privilege, setPrivilege] = React.useState(null);

  const $onLoad = async (id) => {
    const detail = await Dispatch(Shipment.$show(id, { load_shipment: true }));
    if (detail?.message === 'success') {
      setData(detail?.data);
    }
  };

  const $getPriviledge = async () => {
    const pricing = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.pricing',
    });

    setPrivilege(pricing);
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  React.useEffect(() => {
    try {
      // The return value is the canvas element
      bwipjs.toCanvas('mycanvas', {
        bcid: 'code128', // Barcode type
        text: data?.shipment?.code, // Text to encode
        scale: 1.5, // 3x scaling factor
        height: 15, // Bar height, in millimeters
        width: 5,
        includetext: true, // Show human-readable text
        textxalign: 'center', // Always good to set this
      });

      bwipjs.toCanvas('canvas', {
        bcid: 'code128', // Barcode type
        text: data?.shipment?.code, // Text to encode
        scale: 1, // 3x scaling factor
        height: 12, // Bar height, in millimeters
        width: 5,
        includetext: true, // Show human-readable text
        textxalign: 'center', // Always good to set this
      });
    } catch (e) {}

    setLoaded(true);
  }, [data]);

  if (StateLoading && !data) return null;

  if (!loaded) return null;

  return (
    <div>
      {!data || data === null ? null : (
        <Print
          title={`Resi`}
          size="RESI"
          content={renderToString(
            <section className="sheet page-break">
              <div style={{ height: 325 }}>
                <div
                  style={{ paddingTop: 10, paddingLeft: 10, paddingRight: 10 }}
                >
                  <table className="body border">
                    <tr className="border">
                      <td width={'35%'}>
                        <img
                          src={
                            client?.avatar?.replace('_thumb', '') || logoBlack
                          }
                          alt=""
                          style={{ maxHeight: 25, padding: 5 }}
                        />
                      </td>
                      <td
                        colSpan={2}
                        valign="middle"
                        style={{
                          textAlign: 'right',
                          paddingRight: 10,
                          paddingTop: 5,
                        }}
                      >
                        <canvas id="mycanvas"></canvas>
                      </td>
                    </tr>

                    <tr className="border">
                      <td className="border center" width={'61%'} colSpan={2}>
                        <div className="bold elips">
                          {data?.order?.service_type?.name}
                        </div>
                      </td>
                      <td className="border center bold">
                        {(!Session?.privileges || privilege) && (
                          <>
                            <div className="bold">
                              {currencyFormat(data?.total_charges, 'IDR')}
                            </div>
                            {data?.shipment?.cod_value && (
                              <div style={{ fontSize: 8 }}>
                                COD{' '}
                                {currencyFormat(
                                  data?.shipment?.cod_value,
                                  'IDR'
                                )}
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                    <tr className="border">
                      <td
                        className="border"
                        colSpan={2}
                        rowSpan={2}
                        valign="top"
                      >
                        <div style={{ height: 50 }}>
                          <div
                            style={{ fontSize: 9, textTransform: 'capitalize' }}
                          >
                            <b>Pengirim:</b> {data?.shipment?.shipper?.name},{' '}
                            <b>Telp:</b> {data?.shipment?.shipper?.phone}
                          </div>
                          <div
                            style={{
                              fontSize: 9,
                              textTransform: 'uppercase',
                              maxLines: 2,
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {data?.shipment?.shipper?.address}
                          </div>
                        </div>
                      </td>
                      <td className="border left bold">
                        <div
                          className="bold"
                          style={{
                            fontSize: 10,
                            textTransform: 'uppercase',
                          }}
                        >
                          Ref: {data?.shipment?.ref_code || '-'}
                        </div>
                      </td>
                    </tr>

                    <tr className="border">
                      <td className="border center" rowSpan={2}>
                        <div className="bold" style={{ fontSize: 20 }}>
                          {data?.shipment?.destination?.region?.regency_name}
                        </div>
                      </td>
                    </tr>

                    <tr className="border" height="40px">
                      <td className="border" colSpan={2} valign="top">
                        <div style={{ height: 60 }}>
                          <div
                            style={{ fontSize: 9, textTransform: 'capitalize' }}
                          >
                            <b>Penerima:</b> {data?.shipment?.destination?.name}
                            , <b>Telp:</b>{' '}
                            {data?.shipment?.destination?.phone_number}
                          </div>
                          <div
                            style={{
                              fontSize: 9,
                              textTransform: 'uppercase',
                              marginTop: 3,
                              maxLines: 2,
                              textOverflow: 'ellipsis',
                              wordWrap: 'break-word',
                            }}
                          >
                            {data?.shipment?.destination?.address}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr className="border">
                      <td className="border center">
                        <QRImage
                          text={`${POD_URL}/shipment/${data?.shipment_id}`}
                          color="#000"
                          background="#fff"
                          style={{ height: 65 }}
                        />
                      </td>

                      <td className="border" valign="top">
                        <div style={{ fontSize: 10 }}>
                          <b>Deskripsi:</b>
                        </div>
                        {data?.shipment?.items?.map((e, i) => (
                          <div
                            key={i}
                            style={{
                              fontSize: 10,
                              textTransform: 'uppercase',
                              marginTop: 3,
                            }}
                          >
                            {e?.item_name}
                          </div>
                        ))}
                      </td>

                      <td className="border" valign="top">
                        <div
                          style={{
                            fontSize: 9,
                            marginTop: 3,
                          }}
                        >
                          Tanggal: {formatDate(data?.created_at, 'DD/MM/YYYY')}
                        </div>

                        <div
                          style={{
                            fontSize: 9,
                            marginTop: 3,
                          }}
                        >
                          Kota Asal: {data?.current_hub?.region?.regency_name}
                        </div>
                        <div
                          style={{
                            fontSize: 9,
                            marginTop: 3,
                          }}
                        >
                          Berat: {data?.shipment?.total_weight} Kg
                        </div>
                        <div
                          style={{
                            fontSize: 9,
                            marginTop: 3,
                          }}
                        >
                          Jumlah Koli: {data?.shipment?.total_quantity}
                        </div>
                        <div
                          style={{
                            fontSize: 9,
                            marginTop: 3,
                          }}
                        >
                          Jenis Kiriman:{' '}
                          {data?.order?.service_type?.service?.name}
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <div style={{ height: 151 }}>
                <div
                  style={{
                    paddingLeft: 10,
                    paddingRight: 10,
                    paddingBottom: 10,
                  }}
                >
                  <table className="body border">
                    <tr className="border">
                      <td
                        className="border"
                        colSpan={2}
                        valign="middle"
                        style={{
                          textAlign: 'center',
                          paddingTop: 5,
                        }}
                      >
                        <canvas id="canvas"></canvas>
                      </td>
                      <td
                        className="border center"
                        width={'39%'}
                        valign="middle"
                      >
                        <div className="bold center elips">
                          {data?.order?.service_type?.name}
                        </div>
                      </td>
                    </tr>
                    <tr className="border">
                      <td
                        className="border center"
                        style={{ height: 60 }}
                        valign="center"
                        width="20%"
                      >
                        <img
                          src={
                            client?.avatar?.replace('_thumb', '') || logoBlack
                          }
                          alt=""
                          style={{ maxHeight: 18, padding: 5 }}
                        />
                      </td>
                      <td
                        className="border"
                        style={{ maxHeight: 60 }}
                        valign="top"
                      >
                        <div
                          style={{
                            fontSize: 9,
                          }}
                        >
                          Ref: {data?.shipment?.ref_code}
                        </div>
                        <div
                          style={{
                            fontSize: 9,
                            marginTop: 3,
                          }}
                        >
                          Tanggal: {formatDate(data?.created_at)}
                        </div>
                        <div
                          style={{
                            fontSize: 9,
                            marginTop: 3,
                          }}
                        >
                          Kota Asal: {data?.current_hub?.region?.regency_name}
                        </div>
                        <div
                          style={{
                            fontSize: 9,
                            marginTop: 3,
                          }}
                        >
                          Berat: {data?.shipment?.total_weight} Kg
                        </div>
                        <div
                          style={{
                            fontSize: 9,
                            marginTop: 3,
                          }}
                        >
                          Jumlah Koli: {data?.shipment?.total_quantity}
                        </div>
                        <div
                          style={{
                            fontSize: 9,
                            marginTop: 3,
                          }}
                        >
                          Jenis Kiriman:{' '}
                          {data?.order?.service_type?.service?.name}
                        </div>
                      </td>
                      <td className="border" width={'39%'} valign="top">
                        <div style={{ fontSize: 10, marginBottom: 10 }}>
                          <b>Pengirim:</b> {data?.shipment?.shipper?.name},{' '}
                          <b>Telp:</b> {data?.shipment?.shipper?.phone_number}
                        </div>

                        <div style={{ fontSize: 10 }}>
                          <b>Penerima:</b> {data?.shipment?.destination?.name},{' '}
                          <b>Telp:</b>{' '}
                          {data?.shipment?.destination?.phone_number}
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </section>
          )}
        />
      )}
    </div>
  );
};

export default PrintResi;
